import React, { Component, ReactElement } from 'react'
import { Route } from '../Annotation/Route'
import { CommonFormContextProvider } from '../../React/Common/Contexts/CommonFormContext'
import { WelcomeContainer } from '../Components/Organisms/WelcomeContainer/WelcomeContainer'
import { PasswordChange } from '../Components/Organisms/PasswordChange/Main/PasswordChange'
import { StandardContexts } from '../../React/Common/Components/StandardContexts'
import { RouteGuard } from '../Guards/RouteGuard'
import { RouteID } from '../Components/Molecules/Header/Types/Types'

@Route(RouteID.CHANGE_PASSWORD)
export class ChangePasswordPage extends Component {
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.CHANGE_PASSWORD}>
                <StandardContexts>
                    <CommonFormContextProvider>
                        <WelcomeContainer>
                            <PasswordChange />
                        </WelcomeContainer>
                    </CommonFormContextProvider>
                </StandardContexts>
            </RouteGuard>
        )
    }
}
